import { render, staticRenderFns } from "./AddAttribute.vue?vue&type=template&id=389f9374&scoped=true&"
import script from "./AddAttribute.vue?vue&type=script&lang=js&"
export * from "./AddAttribute.vue?vue&type=script&lang=js&"
import style0 from "./AddAttribute.vue?vue&type=style&index=0&id=389f9374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389f9374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('389f9374')) {
      api.createRecord('389f9374', component.options)
    } else {
      api.reload('389f9374', component.options)
    }
    module.hot.accept("./AddAttribute.vue?vue&type=template&id=389f9374&scoped=true&", function () {
      api.rerender('389f9374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/attributes/AddAttribute.vue"
export default component.exports